import { render, staticRenderFns } from "./baseInfoDetail.vue?vue&type=template&id=23e2f618&scoped=true&"
import script from "./baseInfoDetail.vue?vue&type=script&lang=js&"
export * from "./baseInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./baseInfoDetail.vue?vue&type=style&index=0&id=23e2f618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e2f618",
  null
  
)

export default component.exports